import { useMemo } from "react";

export const useMenuSearch = (groups, search) => {
    return useMemo(() => {
        const query = search.trim().toLowerCase();
        if (!query) return groups;
        const out = {};
        Object.keys(groups).forEach((dateKey) => {
            const flights = (groups[dateKey] || []).filter((flight) => {
                const haystack = [
                    flight?.flightNumber,
                    flight?.id,
                    flight?.sDest,
                    flight?.sDestICAO,
                    flight?.sOrigin,
                    flight?.sOriginICAO,
                ]
                    .filter(Boolean)
                    .join(" ")
                    .toLowerCase();
                return haystack.includes(query);
            });
            if (flights.length) out[dateKey] = flights;
        });
        return out;
    }, [groups, search]);
};

export default useMenuSearch;


